/* eslint-disable no-console */
/* eslint-disable no-undef */
// actions
import { updateVehicle } from '../../Vehicle/actions';
// eslint-disable-next-line import/no-cycle
import { getRoute } from '../../RouteBtn/actions';

// helpers
import { makeActionCreator } from '../../../lib/Utils';
// eslint-disable-next-line import/no-cycle
import { restorePlaces } from '../../Places/actions';

export const GOOGLE_SET_MAP = 'GOOGLE_SET_MAP';
export const setGoogleMap = makeActionCreator(GOOGLE_SET_MAP, 'mapLoaded');

export const GOOGLE_SET_ZOOM = 'GOOGLE_SET_ZOOM';
export const setGoogleMapZoom = makeActionCreator(GOOGLE_SET_ZOOM, 'zoom');

export const GOOGLE_SET_LANGUAGE = 'GOOGLE_SET_LANGUAGE';
export const setGoogleMapLanguage = makeActionCreator(
  GOOGLE_SET_LANGUAGE,
  'language',
);

export const GOOGLE_SET_REGION = 'GOOGLE_SET_REGION';
export const setGoogleMapRegion = makeActionCreator(
  GOOGLE_SET_REGION,
  'region',
);

export const GOOGLE_SET_GEOLOCATION = 'GOOGLE_SET_GEOLOCATION';
export const setGoogleMapGeolocation = makeActionCreator(
  GOOGLE_SET_GEOLOCATION,
  'geolocation',
);

export const GOOGLE_SET_ENTRYPOINT = 'GOOGLE_SET_ENTRYPOINT';
export const setGoogleMapEntryPoint = makeActionCreator(
  GOOGLE_SET_ENTRYPOINT,
  'entryPoint',
);

// TODO: add a function that does all of this in one go

export function restoreTripFromURL(data) {
  // eslint-disable-next-line arrow-parens
  return (dispatch, getState) => {
    const {
      numberOfStopoversSingular,
      numberOfStopoversPlural,
    } = getState().Places;

    // Dispatch Vehicle
    // eslint-disable-next-line prefer-destructuring
    const vehicle = data.vehicle;
    const vehicleNode = document.querySelector(
      `[role="menuitem"][data-model="${vehicle.model}"]`,
    );

    if (vehicleNode) {
      dispatch(updateVehicle(vehicleNode));
    }

    // Dispatch Places
    // eslint-disable-next-line prefer-destructuring
    const fields = data.places.fields;
    const places = {
      fields,
      tripIsValid: true,
      numberOfStopoversSingular,
      numberOfStopoversPlural,
    };
    dispatch(restorePlaces(places));

    // Fetch Directions
    dispatch(getRoute(fields, data.vehicle));
  };
}
